export const DICE_ROLLER_MODES = [
  {
    id: 'd4',
    label: 'd4',
    kind: 'die',
    sides: 4,
    description: 'Quick checks and light damage.',
  },
  {
    id: 'd6',
    label: 'd6',
    kind: 'die',
    sides: 6,
    description: 'The classic cube for many board games.',
  },
  {
    id: 'd8',
    label: 'd8',
    kind: 'die',
    sides: 8,
    description: 'Great for martial weapons and encounter tables.',
  },
  {
    id: 'd10',
    label: 'd10',
    kind: 'die',
    sides: 10,
    description: 'Percentile pairs and broad random ranges.',
  },
  {
    id: 'd12',
    label: 'd12',
    kind: 'die',
    sides: 12,
    description: 'Heavy hits and dramatic loot tables.',
  },
  {
    id: 'd20',
    label: 'd20',
    kind: 'die',
    sides: 20,
    description: 'Perfect for DnD attack rolls, saves, and checks.',
  },
  {
    id: 'd100',
    label: 'd100',
    kind: 'die',
    sides: 100,
    description: 'Roll a full percentile in one tap.',
  },
  {
    id: 'coin',
    label: 'Coin',
    kind: 'coin',
    description: 'Settle ties with a simple flip.',
  },
];

export const diceRollerDefinition = {
  id: 'dice-roller',
  name: 'Dice Roller',
  summary: 'Roll polyhedral dice or flip a coin for tabletop sessions without leaving the arcade.',
  instructions: 'Choose a die or coin, then press Roll or Flip. The selection is saved on this device.',
  storageNamespace: 'dice-roller',
  themeClass: 'theme-dice-roller',
  modes: DICE_ROLLER_MODES,
};
